import { createFileRoute, redirect } from '@tanstack/react-router'

import keycloak from '@/core/keycloak'
import SignupEmail from '@/signup/components/SignupEmail/SignupEmail'

export const Route = createFileRoute('/signup/email')({
  beforeLoad: async () => {
    if (!keycloak.authenticated) {
      throw redirect({ href: keycloak.createLoginUrl() })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <SignupEmail />
}
